<script setup lang="ts">
import { computed, inject } from 'vue';
import BProgressBar from '@/components/BProgressBar.vue';
import Star from '@/components/icons/Star.vue';

const props = defineProps<{
  currentSlideIdx: number;
  questionCount: number;
  showProgress: boolean;
  isResultsPage: boolean;
}>();

const emit = defineEmits<{
  (e: 'slide', value: number): void;
}>();

const pageData = inject('pageData') as {
  number: number;
  title: string;
  icon: any;
};
const colorScheme = inject('colorScheme', 'yellow');

const headerColor = computed(() => {
  return {
    purple: 'bg-purple-light',
    yellow: 'bg-yellow-light',
    green: 'bg-green-light',
    blue: 'bg-blue-light',
  }[colorScheme];
});

const textColor = computed(() => {
  return {
    purple: 'text-purple-darker',
    yellow: 'text-yellow-darker',
    green: 'text-green-darker',
    blue: 'text-blue-darker',
  }[colorScheme];
});

const headerHeight = computed(() =>
  props.currentSlideIdx > 0 ? 'h-[156px]' : 'h-[112px]',
);

function onBarSlide(e: number) {
  emit('slide', e);
}
</script>

<template>
  <div :class="[headerHeight, headerColor, 'transition-[height] ']">
    <div
      class="grid grid-rows-1 grid-cols-[0.2fr_3fr_0.4fr] items-center h-[112px]"
    >
      <span class="text-4xl text-white font-black place-self-start pl-6 pt-8"
        >{{ pageData?.number }}.</span
      >

      <div :class="[textColor, 'text-center']">
        <h1
          class="m-0 text-[20px] lg:text-start lg:text-[30px]"
          v-text="pageData?.title"
        ></h1>
      </div>

      <component :is="pageData?.icon" />
    </div>

    <div class="px-8" v-if="props.currentSlideIdx > 0 && props.showProgress">
      <b-progress-bar
        :current="props.currentSlideIdx"
        :max="props.questionCount"
        @slide="onBarSlide"
        interactive
      />
    </div>

    <div
      v-if="props.isResultsPage"
      class="flex justify-center items-center text-sm tracking-[0.5rem] font-medium uppercase text-purple-darker relative"
    >
      <Star class="mr-4" />
      <span class="relative top-[1px]">Resultat</span>
      <Star class="ml-2" />
    </div>
  </div>
</template>
